import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-yichu",
  "use": "icon-form-yichu-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-form-yichu\">\r\n<g>\r\n\t<path d=\"M100,200C44.9,200,0,155.1,0,100S44.9,0,100,0s100,44.9,100,100S155.1,200,100,200z M100,14.3c-47.3,0-85.6,38.4-85.7,85.7\r\n\t\tc0.1,47.3,38.4,85.6,85.7,85.7c47.3,0,85.6-38.4,85.7-85.7C185.6,52.8,147.2,14.3,100,14.3z\" />\r\n\t<path d=\"M49.5,93.2c-4,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1l43.1,0.1l57.9,0.1c4,0,7.1-3.2,7.1-7.1s-3.2-7.1-7.1-7.1\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-yichu.svg
// module id = 4AAI
// module chunks = 13